import { render } from "./OnlineBox.vue?vue&type=template&id=570f3b31&scoped=true"
import script from "./OnlineBox.vue?vue&type=script&lang=js"
export * from "./OnlineBox.vue?vue&type=script&lang=js"

import "./OnlineBox.vue?vue&type=style&index=0&id=570f3b31&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570f3b31"]])

export default __exports__